import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'dateAgo',
  pure: true
})
export class DateAgoPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {
  }
  /**
   *
   * @param value
   * @param args
   */
  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) { // less than 30 seconds ago will show as 'Just now'
        return 'たった今';
      }
      if (seconds > 86400 * 2) {
        return this.datePipe.transform(value, 'yyyy-MM-dd');
      }
      const intervals = {
        年: 31536000,
        月: 2592000,
        週: 604800,
        日: 86400,
        時間: 3600,
        分: 60,
        秒: 1
      };
      let counter;
      // tslint:disable-next-line:forin
      for (const i in intervals) {
        // @ts-ignore
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0) {
          return counter + i + '前'; // singular (1 day ago)
        }
      }
    }
    return value;
  }
}
